import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IScheduler {
  id: number | null;
  collectionName: string | null;
}

const initialState: IScheduler = {
  id: null,
  collectionName: null,
};

export const schedulerSlice = createSlice({
  name: "scheduler",
  initialState,
  reducers: {
    setSchedulerInfo: (state, action: PayloadAction<IScheduler>) => {
      state.id = action.payload.id;
      state.collectionName = action.payload.collectionName;
    },
    resetSchedulerInfo: (state) => {
      state.id = initialState.id;
      state.collectionName = initialState.collectionName;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSchedulerInfo, resetSchedulerInfo } =
schedulerSlice.actions;

export default schedulerSlice.reducer;
